// extracted by mini-css-extract-plugin
export default {"criteriaPreview":"criteriaPreview_criteriaPreview__Yc0LZ","header":"criteriaPreview_header__S-5+u","applyBtn":"criteriaPreview_applyBtn__asUve"};